//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import barCharts from '~/components/burstdetails/barCharts.vue'
import lateralBarCharts from '~/components/burstdetails/lateralBarCharts.vue'
import pieCharts from '~/components/burstdetails/pieCharts.vue'
import mobileTab from '~/components/common/mobileTab.vue'
import breadCrumbs from '~/components/common/breadCrumbs.vue'
export default {
  components: {
    barCharts, pieCharts, lateralBarCharts, mobileTab, 'bread-crumbs': breadCrumbs
  },
  async asyncData ({ $api, store, route, redirect }) {
    const { locale = 'en' } = store.state
    let { period = 1 } = route.query
    let { details: symbol = '' } = route.params
    let thousandPieData = [] // 存储宽度1000以下的饼图数据
    let singleUnderData = [] // 存储宽度1000以下的柱状图数据
    symbol = symbol?.split('.')[0] || ''
    period = Number(period) || 1
    if (!symbol) return redirect(`/${locale}/data/BurstData.html`)
    try {
      let brustDetailData = {}
      if (symbol == 'all') brustDetailData = await $api.burstData.newBrustDetailForAllService({ period })
      else brustDetailData = await $api.burstData.newBrustDetailService({ period, symbol })
      brustDetailData.brustMoneyTrend = brustDetailData?.brustMoneyTrend?.reverse()
      if (symbol == 'all') thousandPieData = brustDetailData?.burstMoneyRate
      else singleUnderData = brustDetailData?.timeDistribution
      return {
        brustName: symbol,
        period,
        brustDetailData,
        thousandPieData,
        singleUnderData
      }
    } catch (error) {}
  },
  data () {
    return {
      pullDownIndex: 0,
      pieTab: [{ // 宽度小于1000时饼图的下拉框数据
        name: 'TYY_000595'
      }, {
        name: 'TYY_000596'
      }, {
        name: 'TYY_000597'
      }],
      pieText: this.$t('TYY_000595'),
      pieNum: 0,
      barTab: [{ // 宽度小于1000时柱状图的下拉框数据
        name: 'TYY_000624'
      }, {
        name: 'TYY_000625'
      }],
      barText: this.$t('TYY_000624'),
      brustName: '', // 币种
      period: 1, // 当前页
      isClick: 0, // 防止重复的tab点击
      brustDetailData: {}, // 页面数据
      tabsIndex: 0, // 当前选中的tab下标
      tabsData: [ // tab数据
        {
          name: '15544'
        },
        {
          name: 'TYY_000183'
        },
        {
          name: 'TYY_000182'
        },
        {
          name: 'TYY_000184'
        }
      ]
    }
  },
  head () {
    return {
      title: this.$t('19852')?.replace('{0}', this.brustName || 'all'),
      meta: [
        { name: 'Keywords', content: this.$t('TYY_000667') },
        { name: 'Description', content: this.$t('19853')?.replace('{0}', this.brustName || 'all') }
      ]
    }
  },
  computed: {
    // 当前屏幕的宽度
    screenWidth () {
      return this.$store.state?.screenWidth || 0
    }
  },
  created () {
    console.log(this.brustDetailData)
    this.tabsIndex = this.period - 1 || 0
    this.isClick = this.period - 1 || 0
  },
  methods: {
    // 移动端顶部下拉框切换
    allTabFn (item) {
      this.handleClick(item.index)
    },
    // 爆仓时间下拉框切换
    mobileTabbar (item) {
      if (item.index == 0) {
        this.singleUnderData = this.brustDetailData?.timeDistribution
        this.barText = this.$t('TYY_000624')
        this.pieNum = 0
      } else {
        this.singleUnderData = this.brustDetailData?.priceDistribution
        this.barText = this.$t('TYY_000625')
        this.pieNum = 1
      }
    },
    // 爆仓品种分布下拉框切换
    mobileTabPie (item) {
      if (item.index == 0) {
        this.thousandPieData = this.brustDetailData?.burstMoneyRate
        this.pieText = this.$t('TYY_000595')
      } else if (item.index == 1) {
        this.thousandPieData = this.brustDetailData?.lotsRate
        this.pieText = this.$t('TYY_000596')
      } else {
        this.thousandPieData = this.brustDetailData?.numRate
        this.pieText = this.$t('TYY_000597')
      }
    },
    // 面包屑导航跳转
    skip (num) {
      if (num == 1) window?.open(this.$store.getters.breadHome)
      else window?.open(`/${this.currLangCode()}/data/BurstData.html`)
    },
    async handleClick (index) {
      if (this.isClick == index) return
      if (this.brustName == 'all') {
        const data = await this.$api.burstData.newBrustDetailForAllClient({ period: index + 1 })
        this.brustDetailData = data
        this.brustDetailData.brustMoneyTrend = this.brustDetailData?.brustMoneyTrend?.reverse()
        this.thousandPieData = this.brustDetailData?.burstMoneyRate
        this.pieText = this.$t('TYY_000595')
        this.pullDownIndex++
        this.tabsIndex = index
        this.isClick = index
      } else {
        const data = await this.$api.burstData.newBrustDetailClient({ period: index + 1, symbol: this.brustName })
        this.brustDetailData = data
        this.brustDetailData.brustMoneyTrend = this.brustDetailData?.brustMoneyTrend?.reverse()
        this.singleUnderData = this.brustDetailData?.timeDistribution
        this.barText = this.$t('TYY_000624')
        this.pieNum = 0
        this.pullDownIndex++
        this.tabsIndex = index
        this.isClick = index
      }
    }
  }
}
